import { Route, Routes } from "react-router-dom";

import { WebLayout } from "../layouts";
import { Login } from "../pages/Login";

import {
  StoreCartPage,
  StoreCatalogPage,
  StoreHomePage,
  StoreProductPage,
} from "../pages/Web";

export function WebRouter() {
  function loadLayout(Page) {
    return (
      <WebLayout>
        <Page />
      </WebLayout>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route path="/" element={loadLayout(StoreHomePage)} />

      <Route path="/catalogo" element={loadLayout(StoreCatalogPage)} />

      <Route
        path="/catalogo/:categorySlug"
        element={loadLayout(StoreCatalogPage)}
      />

      <Route path="/producto/:slug" element={loadLayout(StoreProductPage)} />

      <Route path="/carrito" element={loadLayout(StoreCartPage)} />

      <Route path="*" element={loadLayout(StoreHomePage)} />
    </Routes>
  );
}
